import { render, staticRenderFns } from "./TeacherStatusDeficiency.vue?vue&type=template&id=e35ef188"
import script from "./TeacherStatusDeficiency.vue?vue&type=script&lang=js"
export * from "./TeacherStatusDeficiency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e35ef188')) {
      api.createRecord('e35ef188', component.options)
    } else {
      api.reload('e35ef188', component.options)
    }
    module.hot.accept("./TeacherStatusDeficiency.vue?vue&type=template&id=e35ef188", function () {
      api.rerender('e35ef188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/TeacherStatusDeficiency.vue"
export default component.exports